import { Attributes, Misc, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CashHoldingsExtractReportCriteria extends ValueObject {
    @Rules.Required()
    public staticServiceProviderFileGroupingID: number = 0;

    public serviceProviderGroupingName: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public date: Date | null = null;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}